import { useEffect } from "react";

export default function useBlockNavigation() {
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Refresh
      if (
        e.key === "F5" ||
        (e.ctrlKey && e.key.toLowerCase() === "r") ||
        (e.metaKey && e.key.toLowerCase() === "r")
      ) {
        e.preventDefault();
      }

      // Back (Alt + Left)
      if (e.altKey && e.key === "ArrowLeft") {
        e.preventDefault();
      }
    };

    const handlePopState = () => {
      window.history.pushState(null, "", window.location.href);
    };

    // Push initial state
    window.history.pushState(null, "", window.location.href);

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);
}
